// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .icon-empatica-share {
  transform: scaleX(-1);
}
:host toolbar-comments-likes {
  width: 100%;
}
:host ion-grid {
  margin-right: 0px;
}
:host ion-grid .is-video {
  position: relative;
  width: 100%;
  height: auto;
}
:host ion-grid .is-video .icon-play {
  background-color: white;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  top: calc(50% - 35px);
  padding: 10px 7px 10px 13px;
  left: calc(50% - 35px);
  position: absolute;
  box-shadow: 0px 0px 10px -2px var(--ion-color-dark);
  color: var(--ion-color-dark);
}
:host ion-grid img {
  width: 100%;
  background-color: var(--ion-color-light);
  display: block;
  object-fit: contain;
  object-position: center;
}
:host ion-grid .content {
  padding: var(--small-item-padding) !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
:host ion-grid .content.body {
  margin-top: 15px;
  line-height: 1.5;
}
:host ion-grid .content.body div {
  line-height: 1.5;
}
:host ion-grid .content h2 {
  word-wrap: normal;
  white-space: normal;
}
:host ion-grid .content small {
  color: var(--ion-color-medium);
  margin-bottom: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
:host ion-grid .content .text-and-icon {
  display: flex;
  white-space: pre-wrap;
}
:host ion-grid .content p {
  word-wrap: normal;
  white-space: normal;
  color: var(--ion-color-dark);
}
:host ion-grid .content .bottom-toolbar-container {
  padding: 0px !important;
}
:host ion-footer ion-toolbar {
  padding: 0 !important;
}
:host ion-footer ion-toolbar .toolbar-background {
  background-color: #fff;
}
:host ion-footer ion-toolbar ion-buttons {
  justify-content: space-around;
  display: flex;
  margin: 0;
}
:host ion-footer ion-toolbar ion-buttons .bar-button {
  color: var(--ion-color-dark);
  height: 50px;
  background-color: var(--ion-color-light);
  flex: 1 0;
  border-radius: 0px;
}
:host ion-footer ion-toolbar ion-buttons .bar-button i {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/blog-pages/detail-blog/detail-blog.scss"],"names":[],"mappings":"AACE;EAEE,qBAAA;AAAJ;AAEE;EACE,WAAA;AAAJ;AAEE;EACE,iBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAAN;AACM;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;AACR;AAGI;EACE,WAAA;EAEA,wCAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAKI;EACE,6CAAA;EACA,4BAAA;EACA,yBAAA;AAHN;AAKM;EACE,gBAAA;EAIA,gBAAA;AANR;AAGQ;EACE,gBAAA;AADV;AAMM;EACE,iBAAA;EACA,mBAAA;AAJR;AAOM;EACE,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;AALR;AAQM;EACE,aAAA;EACA,qBAAA;AANR;AASM;EACE,iBAAA;EACA,mBAAA;EACA,4BAAA;AAPR;AAUM;EACE,uBAAA;AARR;AAcI;EACE,qBAAA;AAZN;AAaM;EACE,sBAAA;AAXR;AAcM;EACE,6BAAA;EACA,aAAA;EACA,SAAA;AAZR;AAaQ;EACE,4BAAA;EACA,YAAA;EACA,wCAAA;EACA,SAAA;EACA,kBAAA;AAXV;AAYU;EACE,iBAAA;AAVZ","sourcesContent":[":host {\n  .icon-empatica-share {\n    -webkit-transform: scaleX(-1);\n    transform: scaleX(-1);\n  }\n  toolbar-comments-likes {\n    width: 100%;\n  }\n  ion-grid {\n    margin-right: 0px;\n\n    .is-video {\n      position: relative;\n      width: 100%;\n      height: auto;\n      .icon-play {\n        background-color: white;\n        border-radius: 50%;\n        height: 50px;\n        width: 50px;\n        top: calc(50% - 35px);\n        padding: 10px 7px 10px 13px;\n        left: calc(50% - 35px);\n        position: absolute;\n        box-shadow: 0px 0px 10px -2px var(--ion-color-dark);\n        color: var(--ion-color-dark);\n      }\n    }\n\n    img {\n      width: 100%;\n      //max-height: 70vh;\n      background-color: var(--ion-color-light);\n      display: block;\n      object-fit: contain;\n      object-position: center;\n    }\n\n    .content {\n      padding: var(--small-item-padding) !important;\n      padding-bottom: 0 !important;\n      padding-top: 0 !important;\n\n      &.body{\n        margin-top: 15px;\n        div {\n          line-height: 1.5;\n        }\n        line-height: 1.5;\n      }\n\n      h2 {\n        word-wrap: normal;\n        white-space: normal;\n      }\n\n      small {\n        color: var(--ion-color-medium);\n        margin-bottom: 20px;\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n      }\n\n      .text-and-icon{\n        display: flex;\n        white-space: pre-wrap;\n      }\n\n      p {\n        word-wrap: normal;\n        white-space: normal;\n        color: var(--ion-color-dark);\n      }\n\n      .bottom-toolbar-container {\n        padding: 0px !important;\n      }\n    }\n  }\n\n  ion-footer {\n    ion-toolbar {\n      padding: 0 !important;\n      .toolbar-background {\n        background-color: #fff;\n      }\n\n      ion-buttons {\n        justify-content: space-around;\n        display: flex;\n        margin: 0;\n        .bar-button {\n          color: var(--ion-color-dark);\n          height: 50px;\n          background-color: var(--ion-color-light);\n          flex: 1 0;\n          border-radius: 0px;\n          i {\n            margin-right: 5px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
